import "../JSONTools/JSONformatter.css";
import "./TextUtilities.css";
import ToolHeader from "../../Components/ToolHeader";
import { Row, Col } from "react-bootstrap";
import { useState, useEffect, useMemo, useRef } from "react";
import { LoremIpsumAPI } from "../../Services/APIService";

import FormatterPanel from "../../HomePage/FormatterPanel";
import { OutputHeaderButtons } from "../JSONTools/JSONToolsHeaderButtons";

function getWordCount(value) {
    return (value.match(/\b[\w'-]+\b/g) || []).length;
}

function LorumIpsumGenerator() {
    const [result, setresult] = useState("");
    const [apiError, setApiError] = useState("");
    const [count, setCount] = useState(4);
    const [type, setType] = useState("SENTENCES");
    const [htmlMarkup, setHtmlMarkup] = useState(true);
    const [htmlTag, setHtmlTag] = useState("div");
    const loremRequestId = useRef(0);
    const toolFav = { toolName: "Lorem Ipsum Generator", Iconpath: "/FileCodeRaw.svg" };
    const presets = [1, 3, 5, 10, 25, 50];

    const payload = useMemo(() => ({
        type,
        count: Math.max(1, Number(count) || 1),
        htmlMarkup,
        htmlTag
    }), [type, count, htmlMarkup, htmlTag]);

    

    useEffect(() => {
        const requestId = loremRequestId.current + 1;
        loremRequestId.current = requestId;

        const timeoutId = setTimeout(async () => {
            try {
                const response = await LoremIpsumAPI(payload);

                if (requestId === loremRequestId.current) {
                    setresult(response.data.output);
                    setApiError("");
                }
            } catch (error) {
                if (requestId === loremRequestId.current) {
                    setApiError(error.response?.data?.message || error.message);
                }
            }
        }, 250);

        return () => clearTimeout(timeoutId);
    }, [payload]);

    

    const handleCountChange = (value) => {
        if (value === "") {
            setCount("");
            return;
        }

        setCount(Math.max(1, Number(value)));
    };

    const resultLineCount = result ? result.split("\n").length : 0;

    return (
        <>
            <Col>
                <ToolHeader title="Lorem Ipsum Generator" description="Generate placeholder text for designs and prototypes" toolFav={toolFav} />

                <Row className='Formatter lorem-generator-row'>
                    <Col xs={12} lg={3} className="lorem-controls-column">
                        <div className="lorem-card">
                            <div className="lorem-section-title">GENERATE</div>
                            <div className="generate-row">
                                <input
                                    type="number"
                                    min="1"
                                    value={count}
                                    onChange={(e) => handleCountChange(e.target.value)}
                                    className="count-input"
                                />
                                <select
                                    value={type}
                                    onChange={(e) => setType(e.target.value)}
                                    className="type-select"
                                >
                                    <option value="PARAGRAPHS">Paragraphs</option>
                                    <option value="WORDS">Words</option>
                                    <option value="SENTENCES">Sentences</option>
                                </select>
                            </div>

                            <div className="lorem-section-title preset-space">
                                QUICK PRESETS
                            </div>

                            <div className="preset-grid">
                                {presets.map((num) => (
                                    <button
                                        key={num}
                                        type="button"
                                        className={`preset-btn ${Number(count) === num ? "active" : ""}`}
                                        onClick={() => setCount(num)}
                                    >
                                        {num}
                                    </button>
                                ))}
                            </div>

                            <div className="divider" />

                            <label className="check-row">
                                <input
                                    type="checkbox"
                                    checked={htmlMarkup}
                                    onChange={() => setHtmlMarkup((value) => !value)}
                                />
                                <div>
                                    <div className="check-title">HTML markup</div>
                                    <div className="check-sub">
                                        Wrap with an HTML tag
                                    </div>
                                </div>
                            </label>

                            {htmlMarkup && (
                                <div className="generate-row">
                                    <select
                                        value={htmlTag}
                                        onChange={(e) => setHtmlTag(e.target.value)}
                                        className="type-select"
                                    >
                                        <option value="p">p</option>
                                        <option value="div">div</option>
                                        <option value="span">span</option>
                                        <option value="section">section</option>
                                        <option value="article">article</option>
                                    </select>
                                </div>
                            )}

                            <div className="divider" />

                            <div className="stat-row">
                                <span>Output length:</span>
                                <span>{result.length} chars</span>
                            </div>

                            <div className="stat-row">
                                <span>Words:</span>
                                <span>{getWordCount(result)}</span>
                            </div>
                        </div>
                    </Col>
                    <Col xs={12} lg={9} className="lorem-output-column">
                        <FormatterPanel
                            title="Generated text will appear here"
                            value={result ?? ""}
                            placeholder="output will appear here..."
                            lineCount={resultLineCount}
                            readOnly
                            headerButtons={
                                <OutputHeaderButtons
                                    outputText={result ?? ""}
                                    fileName={htmlMarkup ? "lorem-ipsum.html" : "lorem-ipsum.txt"}
                                    mimeType={htmlMarkup ? "text/html;charset=utf-8" : "text/plain;charset=utf-8"}
                                />
                            }
                            footerLeft={`Characters : ${result.replaceAll(" ", "").length}`}
                            footerRight={apiError ? `Error : ${apiError}` : `Size : ${new Blob([result ?? ""]).size} B`}
                        />
                    </Col>
                </Row>
            </Col >
        </>
    );
}

export default LorumIpsumGenerator;
